'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme),
    _Button = require('../Button'),
    _Button2 = _interopRequireDefault(_Button);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var ThemedButton = (0, _themes.createThemedComponent)(_Button2.default, {
  Button_backgroundColor_themePrimary_disabled: (0, _themes.getStyle)('Switch_backgroundColor_themePrimary_disabled_on'),
  Button_borderRadius: (0, _themes.getStyle)('Switch_borderRadius'),
  Button_paddingHorizontal_small: 0,
  Button_paddingHorizontal_medium: 0,
  Button_paddingHorizontal_large: 0,
  Button_paddingHorizontal_fullWidth: 0
}),
    Styled = {};
Styled.Button = (0, _styledComponents2.default)(ThemedButton).withConfig({
  displayName: 'Switch__Button'
})(['position:relative;width:', ';&::after{content:\'\';position:absolute;top:3px;left:0;box-sizing:border-box;width:', ';height:', ';background:white;border-width:1px;border-style:solid;border-color:', ';border-radius:100%;transition-property:transform;transition-duration:', ';pointer-events:none;}&:disabled{opacity:0.5;}&[aria-pressed=\'false\'],[aria-pressed=\'false\']{background:', ';border-color:', ';&:focus{border-color:', ';}&:hover{border-color:', ';&:focus{border-color:', ';}}&::after{transform:', ';}}&[aria-pressed=\'true\'],[aria-pressed=\'true\']{&::after{border-color:white;transform:', ';}}'], function (props) {
  return (0, _themes.getStyle)('Switch_width_' + props.size)(props);
}, function (props) {
  return (0, _themes.getStyle)('SwitchKnob_width_' + props.size)(props);
}, function (props) {
  return (0, _themes.getStyle)('SwitchKnob_width_' + props.size)(props);
}, (0, _themes.getStyle)('Switch_borderColor_off'), (0, _themes.getStyle)('Switch_transitionDuration'), (0, _themes.getStyle)('Switch_backgroundColor_off'), (0, _themes.getStyle)('Switch_borderColor_off'), (0, _themes.getStyle)('Switch_borderColor_off_focus'), (0, _themes.getStyle)('Switch_borderColor_off_hover'), (0, _themes.getStyle)('Switch_borderColor_off_focus'), function (props) {
  return (0, _themes.getStyle)('SwitchKnob_translateX_' + props.size)(props);
}, function (props) {
  return (0, _themes.getStyle)('SwitchKnob_translateX_' + props.size + '_pressed')(props);
});

var Switch = function (_React$Component) {
  function Switch() {
    _classCallCheck(this, Switch);

    var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this));

    return _this.state = {
      pressed: !1
    }, _this.handleClick = _this.handleClick.bind(_this), _this;
  }

  return _inherits(Switch, _React$Component), _createClass(Switch, [{
    key: 'handleClick',
    value: function handleClick(event) {
      var pressed = this.state.pressed,
          _props = this.props,
          onChange = _props.onChange,
          onClick = _props.onClick;
      this.setState({
        pressed: !pressed
      }), onClick && onClick(event), onChange && onChange(!pressed);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          size = _props2.size,
          themeProp = _props2.theme,
          otherProps = _objectWithoutProperties(_props2, ['size', 'theme']),
          theme = (0, _componentTheme2.default)(themeProp),
          pressed = this.state.pressed;

      return _react2.default.createElement(Styled.Button, _extends({}, otherProps, {
        "aria-pressed": pressed,
        onClick: this.handleClick,
        size: size,
        theme: theme
      }));
    }
  }]), Switch;
}(_react2.default.Component);

Switch.propTypes = {
  disabled: _propTypes2.default.bool,
  labelledBy: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes3.themeShape
}, Switch.defaultProps = {
  size: 'medium',
  theme: (0, _themes.createTheme)()
}, Switch.displayName = 'Switch';
var SwitchWithTheme = (0, _themes.withTheme)(Switch);
SwitchWithTheme.WrappedComponent = Switch, exports.default = SwitchWithTheme;